import React from 'react';
import DropDownArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';

export default {
  customIcon: React.createElement(DropDownArrow, null)
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-superselectfield/es/defaultProps/arrowDownIcon.defaultProps.js
// module id = 1692
// module chunks = 0